import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ArrowRight, Button, Image } from '@outdoor-voices/ui';
import { useContext, useState } from 'react';
import cc from 'classcat';
import { Back } from './Back';
import { CART_URLS } from '../cart/constants';
import { EarnRewards } from '../../components/EarnRewards';
import { fetchError, onConfirmLeave } from './utils';
import { getSizeVerbose } from '../../config/constants-sizes';
import { KitContext } from './context';
import { POST_HEADERS } from '../../config/constants';
import { trackAddToCart } from '../../utils/cart/addTracker';
import Afterpay from '../../components/Afterpay';
import css from './Confirm.module.scss';
import kitCSS from './Kit.module.scss';
import Price from '../../components/Price';
import Shipping from '../product/Shipping';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var queue = [];
export var Confirm = function Confirm() {
  var _useContext = useContext(KitContext),
      kit = _useContext.kit,
      setStep = _useContext.setStep,
      state = _useContext.state;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      fetching = _useState2[0],
      setFetching = _useState2[1];

  var assets = [];
  var products = [];
  var compareAtPrice = 0;
  state.forEach(function (_ref) {
    var colorwayId = _ref.colorwayId,
        productId = _ref.productId,
        options = _ref.options,
        sizeSelected = _ref.sizeSelected;

    var _options$find = options.find(function (option) {
      return option.product.id === productId;
    }),
        product = _options$find.product;

    var colorway = product.colorways.edges.find(function (_ref2) {
      var node = _ref2.node;
      return node.id === colorwayId;
    }).node;
    var variantStacks = colorway.variantStacks;
    var variant = variantStacks.find(function (_ref3) {
      var size = _ref3.size;
      return size === sizeSelected;
    }).variant;
    var asset = colorway.assets.edges.find(function (_ref4) {
      var node = _ref4.node;
      return node.type === 'KIT';
    }) || colorway.assets.edges[0];
    compareAtPrice += variant.price;
    products.push({
      colorway: colorway,
      product: product,
      variant: _objectSpread(_objectSpread({}, variant), {}, {
        size: sizeSelected
      })
    });
    assets.push(asset);
  });

  var queueVariant = function queueVariant(_ref5) {
    var kitRef = _ref5.kitRef,
        product = _ref5.product,
        variant = _ref5.variant;
    var price = variant.price,
        shopifyId = variant.shopifyId,
        size = variant.size;
    var item = {
      id: shopifyId,
      properties: {
        kitId: atob(kit.id).split(':')[1],
        kitRef: kitRef,
        kitName: kit.title,
        name: "".concat(product.title, " - ").concat(size),
        price: price,
        url: window.location.href
      }
    };
    queue.push(item);
  };

  var processQueue = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var variant, body, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              variant = queue.pop();
              window.onbeforeunload = onConfirmLeave;

              if (!(variant === undefined)) {
                _context.next = 7;
                break;
              }

              window.onbeforeunload = null;
              setFetching(false);
              window.location.assign('/cart');
              return _context.abrupt("return");

            case 7:
              // trackAddToCart(variant);
              // console.info(
              //   "Do we need to track this add to cart?",
              //   JSON.stringify(variant)
              // );
              trackAddToCart({
                variantId: variant.id,
                title: variant.name,
                price: variant.price
              });
              body = {
                id: parseInt(variant.id, 10),
                properties: variant.properties,
                quantity: 1
              };
              _context.next = 11;
              return fetch(CART_URLS.ADD, _objectSpread(_objectSpread({}, POST_HEADERS), {}, {
                body: JSON.stringify(body),
                credentials: 'same-origin'
              }));

            case 11:
              response = _context.sent;

              if (response.ok) {
                _context.next = 15;
                break;
              }

              fetchError(response);
              return _context.abrupt("return");

            case 15:
              processQueue();

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function processQueue() {
      return _ref6.apply(this, arguments);
    };
  }();

  var onAddToBag = function onAddToBag() {
    var kitRef = new Date().getTime();
    products.forEach(function (_ref7) {
      var product = _ref7.product,
          variant = _ref7.variant;
      queueVariant({
        kitRef: kitRef,
        product: product,
        variant: variant
      });
    });
    setFetching(true);
    processQueue();
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Back, {}), /*#__PURE__*/_jsxs("div", {
      className: kitCSS.root,
      children: [/*#__PURE__*/_jsx("div", {
        className: cc([kitCSS.assets, css.assets]),
        children: assets.map(function (_ref8, idx) {
          var node = _ref8.node;
          return /*#__PURE__*/_jsx("div", {
            className: css.asset,
            style: {
              aspectRatio: "".concat(node.image.width, " / ").concat(node.image.height)
            },
            children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, node.image), {}, {
              alt: "Flat image of ".concat(products[idx].product.title, " in ").concat(products[idx].colorway.color),
              sizes: [320, 436]
            }))
          }, node.id);
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: kitCSS.sidebar,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.title,
          children: "Review Your Kit"
        }), /*#__PURE__*/_jsx("div", {
          className: css.price,
          children: /*#__PURE__*/_jsx(Price, {
            compareAtPrice: compareAtPrice,
            price: kit.price
          })
        }), /*#__PURE__*/_jsx("div", {
          className: css.products,
          children: products.map(function (_ref9, idx) {
            var colorway = _ref9.colorway,
                product = _ref9.product,
                variant = _ref9.variant;
            return /*#__PURE__*/_jsxs("div", {
              className: css.product,
              children: [/*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("div", {
                  className: css.productTitle,
                  children: product.title
                }), /*#__PURE__*/_jsxs("div", {
                  className: css.option,
                  children: [/*#__PURE__*/_jsx("div", {
                    className: css.label,
                    children: "Color:"
                  }), " ", colorway.color]
                }), /*#__PURE__*/_jsxs("div", {
                  className: css.option,
                  children: [/*#__PURE__*/_jsx("div", {
                    className: css.label,
                    children: "Size:"
                  }), getSizeVerbose(variant.size)]
                })]
              }), /*#__PURE__*/_jsxs("button", {
                "aria-label": "Edit your step ".concat(idx + 1, " selection"),
                className: css.edit,
                onClick: function onClick() {
                  setStep(idx + 1);
                },
                type: "button",
                children: ["Edit ", /*#__PURE__*/_jsx(ArrowRight, {})]
              })]
            }, variant.id);
          })
        }), /*#__PURE__*/_jsx(EarnRewards, {
          price: kit.price
        }), /*#__PURE__*/_jsx("div", {
          className: css.addToBag,
          children: /*#__PURE__*/_jsxs(Button, {
            ariaLabel: "Add products to bag. Redirects to cart page.",
            disabled: fetching,
            onClick: onAddToBag,
            big: true,
            full: true,
            children: ["Add to Bag", /*#__PURE__*/_jsx(Price, {
              compareAtPrice: compareAtPrice,
              price: kit.price
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: css.afterpay,
          children: /*#__PURE__*/_jsx(Afterpay, {
            price: kit.price
          })
        }), /*#__PURE__*/_jsx(Shipping, {})]
      })]
    })]
  });
};